import React from "react";

export function PageHeader({ eyebrow, title, description, actions }: { eyebrow?: string; title: string; description?: string; actions?: React.ReactNode }) {
  return (
    <div className="rise mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div>
        {eyebrow && <p className="eyebrow mb-2">{eyebrow}</p>}
        <h1 data-testid="page-title" className="text-3xl font-semibold tracking-tight text-slate-50 sm:text-4xl">{title}</h1>
        {description && <p className="mt-2 max-w-2xl text-sm text-slate-400">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}

export function EmptyState({ icon, title, text, action, testId }: { icon: React.ReactNode; title: string; text: string; action?: React.ReactNode; testId?: string }) {
  return (
    <div data-testid={testId} className="panel flex flex-col items-center justify-center px-6 py-16 text-center">
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl border border-slate-700 bg-slate-800/60 text-cyan-400">{icon}</div>
      <h3 className="text-lg font-medium text-slate-100">{title}</h3>
      <p className="mt-1 max-w-sm text-sm text-slate-400">{text}</p>
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

export function Loading() {
  return (
    <div data-testid="loading-indicator" className="flex items-center gap-3 py-16 text-sm text-slate-500">
      <span className="h-4 w-4 animate-spin rounded-full border-2 border-slate-700 border-t-cyan-400" />
      Chargement…
    </div>
  );
}
